export const usersApiErrors: Record<string, string> = {
  NOT_FOUND: 'userNotFound',
  FORBIDDEN: 'ownUserEditForbidden',
  USER_NOT_FOUND: 'userNotFound',
};
